<template>
    <section class="lymphomap_main main_dashboard">
        <div class="lymphomap_wrp">
            <div class="dashboard_main_section">
                <div class="main_dashboard_top">
                    <div class="row">
                        <div class="col-md-5 width_resize_5 pr-md-0 animation_zoom_out">
                            <div class="main_dashboard_profile_avtar dashboard_well" v-if="userDetails">
                                <div class="profile_avtar_img">
                                    <template v-if="userDetails.profile.thumbnail">
                                        <div class="prfl_avatar_lazy_load_box">
                                            <img :src="userDetails.profile.thumbnail" class="img-fluid">
                                            <img :src="userDetails.profile.avatar" v-if="userDetails.profile.avatar"
                                                class="img-fluid">
                                        </div>
                                    </template>
                                    <template v-else>
                                        <img src="@/assets/images/user_default.png" class="img-fluid">
                                    </template>
                                </div>
                                <div class="profile_details">
                                    <div class="user_info_name" v-if="userDetails">{{ userDetails.salutation }}
                                        {{ userDetails.first_name }}
                                        {{ userDetails.last_name }}
                                    </div>
                                    <template v-if="userDetails">
                                        <div class="personal_user_d_country" v-if="userDetails.profile">
                                            <template
                                                v-if="userDetails.profile.city">{{ userDetails.profile.city }},</template>
                                            <template v-if="userDetails.profile.country"><span>
                                                    {{ this.getCountryName(userDetails.profile.country) }}</span></template>
                                        </div>
                                    </template>
                                    <div class="change_profile_status">
                                        <div class="change_profile_status_text">Status : </div>
                                        <div class="change_profile_status_action">
                                            <div class="onoffswitch text-left">
                                                <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                                                    id="statusChangedToggle" :checked="userDetails.profile.is_public"
                                                    v-on:click="userStatusUpdatedFun(userDetails, userDetails.profile.is_public)">
                                                <label class="onoffswitch-label" for="statusChangedToggle">
                                                    <span class="onoffswitch-inner"></span>
                                                    <span class="onoffswitch-switch"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="userDetails">
                                        <div class="profile_updation_notification" v-if="!userDetails.pro_payment">
                                            <router-link :to="{ name: 'membershipPackages' }"><i
                                                    class="fa fa-credit-card mr-1" aria-hidden="true"></i> Upgrade
                                                Subscription</router-link>
                                        </div>
                                    </template>
                                    <template v-if="userDetails">
                                        <div class="profile_updation_notification"
                                            v-if="!userDetails.profile.area_of_work || !userDetails.profile.department || !userDetails.profile.designation || !userDetails.profile.mobile || !userDetails.profile.country || !userDetails.profile.city || !userDetails.profile.address">
                                            <i class="fa fa-star-o" aria-hidden="true"></i> Please Update Profile
                                        </div>
                                    </template>
                                </div>
                                <div class="edit_profile">
                                    <router-link to="/profile/update/" title="Edit profile">
                                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                    </router-link>
                                </div>
                            </div>
                            <div class="dashboard_well prfl_info_tabs">
                                <div class="main_dashboard_tabs">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-toggle="tab" href="#tabs-1"
                                                role="tab">Info</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#tabs-2" role="tab">About Me</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#tabs-3" role="tab"
                                                style="letter-spacing: 1px;">CV</a>
                                        </li>
                                    </ul>
                                </div>
                                <!-- Tab panes -->
                                <div class="tab-content" v-if="userDetails">
                                    <div class="tab-pane user_prfl_about_tab_wrp" id="tabs-3" role="tabpanel">
                                        <div class="main_dashboard_user_info">
                                            <template v-if="getAboutInfo">
                                                <template
                                                    v-if="getAboutInfo.form_cv_uploaded && getAboutInfo.pdf_cv_uploaded">
                                                    <ul class="about_user_info_content" v-if="!myCvReUploadSection">
                                                        <li v-if="getAboutInfo.profession">
                                                            I am a/an <span
                                                                class="about_info_value">{{ getAboutInfo.profession }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.treatment_diseases">
                                                            I treat patients with the following diseases: <span
                                                                class="about_info_value">{{ getAboutInfo.treatment_diseases }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.clinical_interest">
                                                            My main clinical interest is in <span
                                                                class="about_info_value">{{ getAboutInfo.clinical_interest }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.surgical_interest">
                                                            My main surgical interest is in <span
                                                                class="about_info_value">{{ getAboutInfo.surgical_interest }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.research_areas">
                                                            My primary research areas are: <span
                                                                v-for="item in getAboutInfo.research_areas"
                                                                class="about_info_value">{{ item }}<i>, </i></span>
                                                        </li>
                                                        <li v-if="getAboutInfo.work_for">
                                                            I work for / am associated with <span
                                                                class="about_info_value">{{ getAboutInfo.work_for }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.degree">
                                                            I am a/an <span
                                                                class="about_info_value">{{ getAboutInfo.degree }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.experience">
                                                            I have <span
                                                                class="about_info_value">{{ getAboutInfo.experience }}</span>
                                                            years of
                                                            professional experience.
                                                        </li>
                                                        <li v-if="getAboutInfo.language">
                                                            I have language proficiency in <span
                                                                v-for="item in getAboutInfo.language"
                                                                class="about_info_value">{{ item }}<i>, </i></span>
                                                        </li>
                                                    </ul>
                                                    <div class="my_cv_section" v-if="myCvReUploadSection">
                                                        <div class="cv_reupload">
                                                            <label for="cv_reupload" class="cv_reupload_label"
                                                                :disabled="cvUploadLoader">
                                                                <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                                                                <span class="reupload_content">Re Upload CV</span>
                                                            </label>
                                                            <input type="file" name="file" id="cv_reupload" ref="file"
                                                                @change="handleReuploadCvUploadMethod" accept=".pdf"
                                                                hidden :disabled="cvUploadLoader" />
                                                            <div class="cv_loader_f_re" v-if="cvUploadLoader">
                                                                <img src="@/assets/images/progressbar.gif"
                                                                    class="img-fluid">
                                                            </div>
                                                        </div>
                                                        <div class="my_cv_box pt-4">
                                                            <div class="row align-items-center">
                                                                <div class="col-auto pr-2">
                                                                    <img src="@/assets/images/filetype/pdf.png"
                                                                        class="img-fluid" width="30">
                                                                </div>
                                                                <div class="col pr-0 pl-0">
                                                                    <a :href="getAboutInfo.cv" class="cv_filename"
                                                                        target="_blank">{{ getAboutInfo.cv_filename }}</a>
                                                                </div>
                                                                <div class="col-auto ml-auto pl-2">
                                                                    <button class="btn btn-danger"
                                                                        @click="deleteCvFromMyBucketMethod"><i
                                                                            class="fa fa-trash"></i></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="cv_tab_f_toolbar">
                                                        <div class="row">
                                                            <div class="col">
                                                                <button class="btn btn-primary mr-3"
                                                                    v-on:click="openUpdateAboutPopup()">Update</button>
                                                                <label class="btn btn-primary mb-0"
                                                                    @click="cvTabChangedMethod()"
                                                                    :class="myCvReUploadSection ? 'active' : ''">My
                                                                    CV</label>
                                                            </div>
                                                            <div class="col-auto ml-auto">
                                                                <a href="javascript:void(0)" class="upload_cv_file"
                                                                    @click="downloadFile(getAboutInfo.cv, getAboutInfo.cv_filename)"><i
                                                                        class="fa fa-download"
                                                                        aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else-if="getAboutInfo.form_cv_uploaded">
                                                    <ul class="about_user_info_content">
                                                        <li v-if="getAboutInfo.profession">
                                                            I am a/an <span
                                                                class="about_info_value">{{ getAboutInfo.profession }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.treatment_diseases">
                                                            I treat patients with the following diseases: <span
                                                                class="about_info_value">{{ getAboutInfo.treatment_diseases }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.clinical_interest">
                                                            My main clinical interest is in <span
                                                                class="about_info_value">{{ getAboutInfo.clinical_interest }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.surgical_interest">
                                                            My main surgical interest is in <span
                                                                class="about_info_value">{{ getAboutInfo.surgical_interest }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.research_areas">
                                                            My primary research areas are: <span
                                                                v-for="item in getAboutInfo.research_areas"
                                                                class="about_info_value">{{ item }}<i>, </i></span>
                                                        </li>
                                                        <li v-if="getAboutInfo.work_for">
                                                            I work for / am associated with <span
                                                                class="about_info_value">{{ getAboutInfo.work_for }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.degree">
                                                            I am a/an <span
                                                                class="about_info_value">{{ getAboutInfo.degree }}</span>
                                                        </li>
                                                        <li v-if="getAboutInfo.experience">
                                                            I have <span
                                                                class="about_info_value">{{ getAboutInfo.experience }}</span>
                                                            years of
                                                            professional experience.
                                                        </li>
                                                        <li v-if="getAboutInfo.language">
                                                            I have language proficiency in <span
                                                                v-for="item in getAboutInfo.language"
                                                                class="about_info_value">{{ item }}<i>, </i></span>
                                                        </li>
                                                    </ul>
                                                    <div class="cv_tab_f_toolbar">
                                                        <div class="row">
                                                            <div class="col">
                                                                <button class="btn btn-primary mr-3"
                                                                    v-on:click="openUpdateAboutPopup()">Update</button>
                                                                <label class="btn btn-primary mb-0" for="cv_upload"
                                                                    v-if="!getAboutInfo.pdf_cv_uploaded"
                                                                    :disabled="cvUploadLoader">
                                                                    Upload
                                                                    <input type="file" name="file" id="cv_upload"
                                                                        ref="file" @change="handleCVUploadMethod"
                                                                        accept=".pdf" hidden
                                                                        :disabled="cvUploadLoader" />
                                                                </label>
                                                                <img src="@/assets/images/progressbar.gif"
                                                                    class="img-fluid ml-3" v-if="cvUploadLoader"
                                                                    width="30">
                                                            </div>
                                                            <div class="col-auto ml-auto">
                                                                <a href="javascript:void(0)" class="upload_cv_file"
                                                                    @click="downloadFile(getAboutInfo.cv, getAboutInfo.cv_filename)"><i
                                                                        class="fa fa-download"
                                                                        aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else-if="getAboutInfo.pdf_cv_uploaded">
                                                    <div class="my_cv_section">
                                                        <div class="cv_reupload">
                                                            <label for="cv_reupload" class="cv_reupload_label"
                                                                :disabled="cvUploadLoader">
                                                                <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                                                                <span class="reupload_content">Re Upload CV</span>
                                                            </label>
                                                            <input type="file" name="file" id="cv_reupload" ref="file"
                                                                @change="handleReuploadCvUploadMethod" accept=".pdf"
                                                                hidden :disabled="cvUploadLoader" />
                                                            <div class="cv_loader_f_re" v-if="cvUploadLoader">
                                                                <img src="@/assets/images/progressbar.gif"
                                                                    class="img-fluid">
                                                            </div>
                                                        </div>
                                                        <div class="my_cv_box pt-4">
                                                            <div class="row align-items-center">
                                                                <div class="col-auto pr-2">
                                                                    <img src="@/assets/images/filetype/pdf.png"
                                                                        class="img-fluid" width="30">
                                                                </div>
                                                                <div class="col pr-0 pl-0">
                                                                    <a :href="getAboutInfo.cv" class="cv_filename"
                                                                        target="_blank">{{ getAboutInfo.cv_filename }}</a>
                                                                </div>
                                                                <div class="col-auto ml-auto pl-2">
                                                                    <button class="btn btn-danger"
                                                                        @click="deleteCvFromMyBucketMethod"><i
                                                                            class="fa fa-trash"></i></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="cv_tab_f_toolbar">
                                                        <div class="row">
                                                            <div class="col">
                                                                <button class="mr-3 btn btn-primary"
                                                                    @click="openAddAboutPopup">Quick Add</button>
                                                                <label class="btn btn-primary mb-0 active"
                                                                    style="cursor:default;">My CV</label>
                                                            </div>
                                                            <div class="col-auto ml-auto">
                                                                <a href="javascript:void(0)" class="upload_cv_file"
                                                                    @click="downloadFile(getAboutInfo.cv, getAboutInfo.cv_filename)"><i
                                                                        class="fa fa-download"
                                                                        aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="cv_tab_f_toolbar">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <button class="mr-3 btn btn-primary"
                                                                    @click="openAddAboutPopup">Quick Add</button>
                                                                <label class="btn btn-primary mb-0" for="cv_upload"
                                                                    :disabled="cvUploadLoader">
                                                                    Upload
                                                                    <input type="file" name="file" id="cv_upload"
                                                                        ref="file" @change="handleCVUploadMethod"
                                                                        accept=".pdf" hidden
                                                                        :disabled="cvUploadLoader" />
                                                                </label>
                                                                <img src="@/assets/images/progressbar.gif"
                                                                    class="img-fluid ml-3" v-if="cvUploadLoader"
                                                                    width="30">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <div class="cv_tab_f_toolbar">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <button class="mr-3 btn btn-primary"
                                                                @click="openAddAboutPopup">Quick Add</button>
                                                            <label class="btn btn-primary mb-0" for="cv_upload"
                                                                :disabled="cvUploadLoader">
                                                                Upload
                                                                <input type="file" name="file" id="cv_upload" ref="file"
                                                                    @change="handleCVUploadMethod" accept=".pdf" hidden
                                                                    :disabled="cvUploadLoader" />
                                                            </label>
                                                            <img src="@/assets/images/progressbar.gif"
                                                                class="img-fluid ml-3" v-if="cvUploadLoader" width="30">
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="tab-pane active" id="tabs-1" role="tabpanel">
                                        <div class="main_dashboard_user_info info_ab_tab_contnent">
                                            <div class="user_info_label" v-if="userDetails.email">
                                                <div class="user_info_label_key">
                                                    <img src="@/assets/images/info_icon/mail_icon.png"
                                                        class="img-fluid">
                                                </div>
                                                <div class="user_info_label_value" v-if="userDetails">
                                                    {{ userDetails.email }}</div>
                                            </div>
                                            <div class="user_info_label" v-if="userDetails.profile.mobile">
                                                <div class="user_info_label_key">
                                                    <img src="@/assets/images/info_icon/mobile_icon.png"
                                                        class="img-fluid">
                                                </div>
                                                <div class="user_info_label_value" v-if="userDetails">
                                                    {{ userDetails.profile.mobile_country_code }}
                                                    {{ userDetails.profile.mobile }}</div>
                                            </div>
                                            <div class="user_info_label" v-if="userDetails.profile.designation">
                                                <div class="user_info_label_key">
                                                    <img src="@/assets/images/info_icon/designation_icon.png"
                                                        class="img-fluid">
                                                </div>
                                                <div class="user_info_label_value">{{ userDetails.profile.designation }}
                                                </div>
                                            </div>
                                            <div class="user_info_label" v-if="userDetails.profile.department">
                                                <div class="user_info_label_key">
                                                    <img src="@/assets/images/info_icon/depart_icon.png"
                                                        class="img-fluid" style="max-width: 30px;">
                                                </div>
                                                <div class="user_info_label_value">{{ userDetails.profile.department }}
                                                </div>
                                            </div>
                                            <div class="user_info_label" v-if="userDetails.profile.area_of_work">
                                                <div class="user_info_label_key">
                                                    <img src="@/assets/images/info_icon/organisation_ico.png"
                                                        class="img-fluid">
                                                </div>
                                                <div class="user_info_label_value">{{ userDetails.profile.area_of_work }}
                                                </div>
                                            </div>
                                            <div class="user_info_label" v-if="userDetails.profile.address">
                                                <div class="user_info_label_key"
                                                    :class="userDetails.profile.address.length > 42 ? 'label_line_break' : ''">
                                                    <img src="@/assets/images/info_icon/address_ico.png"
                                                        class="img-fluid">
                                                </div>
                                                <div class="user_info_label_value" v-if="userDetails">
                                                    {{ userDetails.profile.address }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="tabs-2" role="tabpanel">
                                        <div class="main_dashboard_user_info">
                                            <div class="user_info_label align-items-start"
                                                v-if="userDetails.profile.bio">
                                                <div class="user_info_label_value bio_text_read_more text-justify"
                                                    v-if="(userDetails.profile.bio).length > 245">
                                                    <div class="editor_bio_text"
                                                        v-html="userDetails.profile.bio.substring(0, 450) + '...'">
                                                    </div>
                                                    <div class="text-right"><span class="bio_read_more_btn"
                                                            v-on:click="bioReadMoreFun(userDetails.profile.bio)">Read
                                                            More</span>
                                                    </div>
                                                </div>
                                                <div class="user_info_label_value text-justify" v-else>
                                                    <div class="editor_bio_text" v-html="userDetails.profile.bio"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col pl-2 animation_zoom_out" v-if="!isMobile">
                            <div class="member_list_filters_wrp">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="total_count_box active" v-on:click="homeFilterFun('blog', '1')"
                                            id="homeFilterTab1">
                                            <div class="count_icon"><span>
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30"
                                                        height="30" x="0" y="0" viewBox="0 0 512 512"
                                                        style="enable-background:new 0 0 512 512" xml:space="preserve"
                                                        class="">
                                                        <g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                                <g>
                                                                    <path
                                                                        d="M467,0H45C20.186,0,0,20.186,0,45v76h512V45C512,20.186,491.814,0,467,0z M75,90c-8.284,0-15-6.716-15-15    c0-8.286,6.716-15,15-15s15,6.714,15,15C90,83.284,83.284,90,75,90z M135,90c-8.284,0-15-6.716-15-15c0-8.286,6.716-15,15-15    s15,6.714,15,15C150,83.284,143.284,90,135,90z M195,90c-8.284,0-15-6.716-15-15c0-8.286,6.716-15,15-15s15,6.714,15,15    C210,83.284,203.284,90,195,90z"
                                                                        fill="#ffc107" data-original="#000000"
                                                                        class="" />
                                                                </g>
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                                <g>
                                                                    <path
                                                                        d="M0,151v316c0,24.814,20.186,45,45,45h422c24.814,0,45-20.186,45-45V151H0z M60,197c0-8.291,6.709-15,15-15h150    c8.291,0,15,6.709,15,15v120c0,8.291-6.709,15-15,15H75c-8.291,0-15-6.709-15-15V197z M437,452H75c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h362c8.291,0,15,6.709,15,15C452,445.291,445.291,452,437,452z M437,392H75c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h362c8.291,0,15,6.709,15,15C452,385.291,445.291,392,437,392z M437,332H285c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h152c8.291,0,15,6.709,15,15C452,325.291,445.291,332,437,332z M437,272H285c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h152c8.291,0,15,6.709,15,15S445.291,272,437,272z"
                                                                        fill="#ffc107" data-original="#000000"
                                                                        class="" />
                                                                </g>
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                                <g>
                                                                    <rect x="90" y="212" width="120" height="90"
                                                                        fill="#ffc107" data-original="#000000"
                                                                        class="" />
                                                                </g>
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                            <g xmlns="http://www.w3.org/2000/svg">
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </span></div>
                                            <div class="count_title_w_n">
                                                <span class="count_title">Blogs</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="total_count_box" v-on:click="homeFilterFun('demoRequests', '3')"
                                            id="homeFilterTab3">
                                            <div class="count_icon">
                                                <span>
                                                    <i class="fa fa-laptop" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <div class="count_title_w_n">
                                                <span class="count_title">Request <br> demo</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="total_count_box" v-on:click="homeFilterFun('Patients', '2')"
                                            id="homeFilterTab2">
                                            <div class="count_icon"><span>
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30"
                                                        height="30" x="0" y="0" viewBox="0 0 24 24"
                                                        style="enable-background:new 0 0 512 512" xml:space="preserve">
                                                        <g>
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m15.25 24h-14.5c-.414 0-.75-.336-.75-.75v-3.5c0-2.067 1.683-3.75 3.75-3.75h8.5c2.067 0 3.75 1.683 3.75 3.75v3.5c0 .414-.336.75-.75.75z"
                                                                fill="#ffc107" data-original="#000000" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m8 4c-3.033 0-5.5 2.467-5.5 5.5v2.75c0 .965.785 1.75 1.75 1.75h3.75c-1.937 0-3.5-1.563-3.5-3.5 2.333 0 3.5-1.75 3.5-3.5 0 1.75 1.167 3.5 3.5 3.5 0 1.937-1.563 3.5-3.5 3.5h3.75c.965 0 1.75-.785 1.75-1.75v-2.75c0-3.033-2.467-5.5-5.5-5.5z"
                                                                fill="#ffc107" data-original="#000000" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m22.25 0h-5.5c-.965 0-1.75.785-1.75 1.75v4.75c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-4.75c0-.965-.785-1.75-1.75-1.75zm-1 5.75h-1v1c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1h-1c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1v-1c0-.414.336-.75.75-.75s.75.336.75.75v1h1c.414 0 .75.336.75.75s-.336.75-.75.75z"
                                                                fill="#ffc107" data-original="#000000" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m17.5 21h-2.25c-.553 0-1-.447-1-1s.447-1 1-1h2.25c.552 0 1-.448 1-1v-7.5c0-.552.447-1 1-1s1 .448 1 1v7.5c0 1.654-1.346 3-3 3z"
                                                                fill="#ffc107" data-original="#000000" />
                                                        </g>
                                                    </svg>
                                                </span></div>
                                            <div class="count_title_w_n">
                                                <span class="count_title">Clinical <br> Records</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <router-link :to="{ name: 'paperPiles' }" style="text-decoration:none;">
                                            <div class="total_count_box awerack_tab">
                                                <div class="count_icon"><span>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            xmlns:svgjs="http://svgjs.com/svgjs" version="1.1"
                                                            width="30" height="30" x="0" y="0" viewBox="0 0 247 247"
                                                            style="enable-background:new 0 0 512 512"
                                                            xml:space="preserve" class="">
                                                            <g>
                                                                <path xmlns="http://www.w3.org/2000/svg"
                                                                    d="M171.333,48c-4.143,0-7.833-3.357-7.833-7.5V0H41.333C37.19,0,33.5,3.357,33.5,7.5v231c0,4.133,3.51,7.737,7.644,7.75  L206.311,247c0.008,0,0.015,0,0.015,0c1.993,0,3.731-1.037,5.136-2.438c1.412-1.407,2.039-3.568,2.039-5.562V48H171.333z   M171.833,181h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,181,171.833,181z   M171.833,148h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,148,171.833,148z   M171.833,115h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,115,171.833,115z   M171.833,84h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,84,171.833,84z M210.767,33  H178.5V2.383L210.767,33z"
                                                                    fill="#ffc107" data-original="#000000" class="" />
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                                <g xmlns="http://www.w3.org/2000/svg">
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </span>
                                                </div>
                                                <div class="count_title_w_n">
                                                    <span class="count_title normal_txt">AweRack</span>
                                                    <span class="count_title hover_txt">Research <br> Papers</span>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="main_dashboard_updates dashboard_well p-0">
                                <blog-list v-if="blogActv == 'blog'" :userInfo="userDetails"></blog-list>
                                <demo-requests-list v-else-if="blogActv == 'demoRequests'"></demo-requests-list>
                                <div class="blog_info_wrps" v-else-if="blogActv == 'Patients'">
                                    <div class="coming_soon_tab">
                                        <h4 data-text="Coming soon...">Coming soon...</h4>
                                    </div>
                                </div>
                                <div v-else class="coming_soon_tab">
                                    <h4 data-text="Coming soon...">Coming soon...</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <full-bio-popup v-if="bioFullDataPopup" :bio="bioFullData"></full-bio-popup>
            <add-about-user-info v-if="addAboutPopupState"></add-about-user-info>
            <about-user-info v-if="aboutUserInfoPopupState"></about-user-info>
    </section>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import aboutOfUserInfo from '@/components/private/user/about-of-user-info/index.vue';
import addAboutOfUserInfo from '@/components/private/user/add-about-of-user-info/index.vue';
import axios from 'axios';
import blogList from '@/components/private/blog/list.vue';
import { bus } from '@/main';
import countries from '@/services/country.json'
import demoRequestsList from '@/components/private/demoRequests/list.vue';
import fullBioPopup from '@/components/private/dashboard/full-bio-for-popup/';
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
    name: 'home-dashboard',
    components: {
        'about-user-info': aboutOfUserInfo,
        'add-about-user-info': addAboutOfUserInfo,
        'full-bio-popup': fullBioPopup,
        'blog-list': blogList,
        'demo-requests-list': demoRequestsList
    },
    props: [],
    data() {
        return {
            userDetails: null,
            loadmoreData: {},
            userLoading: false,
            nextStep: '',
            bioFullData: '',
            bioFullDataPopup: false,
            selfUserId: '',
            blogActv: 'blog',
            countryList: [],
            aboutUserInfoPopupState: false,
            getAboutInfo: '',
            addAboutPopupState: false,
            isMobile: false,
            file: null,
            myCvReUploadSection: false,
            cvUploadLoader: false
        }
    },
    computed: {
        ...mapGetters([
            'selfUserInfoGetters',
            'getAboutDetailsOfProfileGetters'
        ]),
        getUserDetailsAgainFun() {
            this.userDetails = this.$store.getters.selfUserInfoGetters.data;
            return;
        },
        getAboutInfoFun() {
            this.getAboutInfo = this.$store.getters.getAboutDetailsOfProfileGetters.data;
            return;
        }
    },
    mounted() {
        if (localStorage.getItem('LoginedUserID')) {
            this.selfUserId = localStorage.getItem('LoginedUserID');
        }
        Object.keys(countries).map((key, index) => {
            this.countryList.push({
                name: countries[key].toLowerCase(),
                value: key.toLowerCase()
            })
        });
        this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1);
        this.getUserDetailsAgainFun;
        this.getAboutInfoFun;
        bus.$on('aboutUserInfoPopupStateBus', (data) => {
            this.aboutUserInfoPopupState = data;
            this.myCvReUploadSection = false;
        });
        bus.$on('addAboutPopupStateBus', (data) => {
            this.addAboutPopupState = data;
            this.myCvReUploadSection = false;
        });
        bus.$on('bioFullDataPopupBus', (data) => {
            this.bioFullDataPopup = data;
        });
    },
    methods: {
        downloadFile(url, filename) {
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function () {
                const url = URL.createObjectURL(this.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            };
            xhr.open('GET', url);
            xhr.send();
        },
        deleteCvFromMyBucketMethod() {
            this.$store.dispatch('deleteCVbyUserIdAction').then((res) => {
                toast.success("Cv deleted has been successfully");
                this.myCvReUploadSection = false
                this.$store.dispatch('getAboutDetailsOfProfileFun')
            }).catch((err) => {
            })
        },
        cvTabChangedMethod() {
            if (this.myCvReUploadSection == true) {
                this.myCvReUploadSection = false
            } else {
                this.myCvReUploadSection = true
            }
        },
        handleReuploadCvUploadMethod(event) {
            if (event.target.files && event.target.files.length > 0) {
                const file = event.target.files[0];
                this.file = event.target.files[0];
                this.$store.dispatch('deleteCVbyUserIdAction').then((res) => {
                    var formData = new FormData();
                    formData.append('cv', this.file);
                    formData.append('cv_filename', file.name);
                    formData.append('pdf_cv', this.file);
                    this.cvUploadLoader = true;
                    this.$store.dispatch('uploadUsrCVAction', formData).then((res) => {
                        toast.success(res.data.msg);
                        this.cvUploadLoader = false;
                        this.$store.dispatch('getAboutDetailsOfProfileFun')
                    }).catch((err) => {
                        this.cvUploadLoader = false;
                        this.file = null
                    })
                })
            }
        },
        handleCVUploadMethod(event) {
            if (event.target.files && event.target.files.length > 0) {
                const file = event.target.files[0];
                this.file = event.target.files[0];
                var formData = new FormData();
                formData.append('cv', this.file);
                formData.append('cv_filename', file.name);
                formData.append('pdf_cv', this.file);
                this.cvUploadLoader = true;
                this.$store.dispatch('uploadUsrCVAction', formData).then((res) => {
                    toast.success(res.data.msg);
                    this.cvUploadLoader = false;
                    this.$store.dispatch('getAboutDetailsOfProfileFun')
                }).catch((err) => {
                    this.cvUploadLoader = false;
                    this.file = null
                })
            }
        },
        onResize() {
            this.isMobile = window.innerWidth < 769
        },
        openAddAboutPopup() {
            this.addAboutPopupState = true;
        },
        openUpdateAboutPopup() {
            this.aboutUserInfoPopupState = true
        },
        getHtmlValOfEditor(htmlString) {
            var stripedHtml = $("<div>").html(htmlString).text();
            // var newStripedHtml = stripedHtml.replace(':', /(\n)/g)
            var customItems = stripedHtml.split(":");
            for (let i = 0; i < customItems.length; i++) {
                customItems[i] = customItems[i] + "\n";
            }
            customItems = customItems.join("");
            return customItems;
        },
        homeFilterFun(checkItem, param) {
            $('.total_count_box').removeClass('active');
            $('#homeFilterTab' + param).addClass('active');
            this.blogActv = checkItem
        },
        bioReadMoreFun(data) {
            this.bioFullData = data
            this.bioFullDataPopup = true
            document.body.classList.add('body_right_scroll_remove');
        },
        showLoadMoreDataFun(url) {
            this.userLoading = true
            console.log(url, "Next URL LINK")
            axios.get(url).then((response) => {
                console.log(response.data.data.next)
                this.loadmoreData = response.data
                this.nextStep = this.loadmoreData.data.next
                this.$set(this.userUpdatesList, 'next', this.nextStep)
                if (this.loadmoreData != undefined) {
                    for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
                        this.userUpdatesList.push(this.loadmoreData.data.results[i]);
                        this.userLoading = false
                    }
                }
            });
        },
        getUserDetailsAgain() {
            this.$store.dispatch('fetchCurrentUserInfo').then((res) => {
                this.userDetails = res.data.data
            }).catch((err) => {
            })
        },
        userStatusUpdatedFun(userDetails, userStatus) {
            var is_public = userStatus
            if (userStatus == false) {
                is_public = true
            } else {
                is_public = false
            }
            let data = new FormData();
            data.append('is_public', is_public);
            this.$store.dispatch('updateProfileFun', data)
                .then((res) => {
                    toast.success(res.data.msg);
                    this.getUserDetailsAgain()
                }).catch((err) => {
                    toast.error(err.data.user_msg || err.data.data.email);
                })
            return;
        },
        getCountryName(countryCode) {
            if (countryCode == null) {
                countryCode = ''
            }
            let countryName = countryCode.toLowerCase()
            let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
            if (country && country.length > 0) {
                country = country[0]
                country = country.name
            } else {
                country = ''
            }
            return country;
        },
    },
    watch: {
        getUserDetailsAgainFun() {
            return this.$store.getters.selfUserInfoGetters;
        },
        getAboutInfoFun() {
            return this.$store.getters.getAboutDetailsOfProfileGetters;
        }
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('body_right_scroll_remove');
        next();
    },
    created() {
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true });
        }
    },
}
</script>

<style lang="scss" scoped>
.main_dashboard {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    letter-spacing: 0.5px;
    color: #ffffff;

    .dashboard_well {
        padding: 15px 10px;
        position: relative;
        background: rgba(0, 0, 0, .75);
        -webkit-box-shadow: -5px 5px 10px rgba(138, 145, 153, .06);
        box-shadow: -5px 5px 10px rgba(138, 145, 153, .06);
        border-radius: 5px;
        margin-bottom: 0px;

        @media only screen and (max-width:767px) {
            padding: 10px;
        }

        .info_ab_tab_contnent {
            padding: 0px 10px;
        }
    }

    .user_info_label {
        display: flex;
        align-items: center;
        font-size: 18px;
        margin-bottom: 15px;
        // transition:all ease 0.5s;
        // -webkit-transition:all ease 0.5s;
        // -moz-transition:all ease 0.5s;
    }

    .user_info_label_key {
        width: 45px;
        flex: 0 0 45px;
        color: #ffd700;
        font-size: 18px;

        &.label_line_break {
            align-self: flex-start;
            margin-top: 3px;
        }
    }

    .main_dashboard_updates {

        // width: 260px;
        h3 {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
        }
    }

    .main_dashboard_btm {
        margin-top: 15px;

        .dashboard_well {
            min-height: calc(100dvh - 97px);
        }
    }

    .updates_list {
        margin: 0;
        padding: 0;

        li {
            margin-bottom: 10px;
            color: #fbf7a5;

            .fa {
                margin-right: 8px;
                font-size: 12px;
            }
        }
    }

    .main_dashboard_tabs {
        padding: 0 10px 15px;

        @media only screen and (max-width:767px) {
            padding: 0 0px 10px;
        }

        .nav-tabs {
            border-bottom: none;
            display: flex;
            flex-wrap: wrap;

            .nav-item {
                flex-grow: 1;

                &:nth-child(2) {
                    padding: 0 30px;
                }

                @media only screen and (max-width:767px) {
                    &:nth-child(2) {
                        padding: 0 8px !important;
                    }
                }
            }
        }

        .nav-link {
            padding: 6px 25px;
            border: none;
            margin-right: 0px;
            border-radius: 50px !important;
            background: hsla(0, 0%, 100%, .12);
            color: #ffd400;
            margin-bottom: 5px;
            display: inline-block;
            height: auto;
            border: none !important;
            font-size: 18px;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            display: block;
            text-align: center;

            @media only screen and (max-width:767px) {
                padding: 5px 15px;
            }

            &:hover {
                background: #87cefa;
                color: #22292f;
            }
        }

        .nav-item:last-child .nav-link {
            margin-right: 0px;
        }

        .nav-link.active {
            background: #87cefa;
            color: #22292f;
        }
    }

    .main_dashboard_profile_avtar {
        display: flex;
        min-height: 210px;
        align-items: center;

        @media only screen and(max-width:767px) {
            align-items: start;
            min-height: inherit;
        }
    }

    .profile_avtar_img {
        max-width: 180px;
        width: 100%;

        @media only screen and(max-width:767px) {
            max-width: 130px;
        }
    }

    .profile_details {
        margin-left: 15px;
        text-align: left;

        @media only screen and(max-width:767px) {
            margin-left: 10px;
        }
    }

    .user_info_name {
        font-size: 24px;
        margin-bottom: 0px;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
        line-height: 1.2;

        @media only screen and(max-width:1310px) {
            font-size: 20px;
        }
    }

    .user_info_last_login {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
    }

    .main_dashboard_updates.dashboard_well {
        min-height: calc(100% - 95px);
    }

    .prfl_info_tabs {
        margin-top: 5px;
        min-height: calc(100dvh - 305px);
    }

    .edit_profile {
        position: absolute;
        top: 5px;
        right: 5px;

        @media only screen and (max-width:480px) {
            top: -10px;
            right: 0;
        }

        .fa {
            font-size: 24px;
            color: #ffffff;

            @media only screen and (max-width:480px) {
                font-size: 20px;
            }

            &:hover {
                color: #ffd400;
            }
        }
    }

    .edit_profile img {
        cursor: pointer;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;
    }

    .load_more_btn:hover {
        color: #000 !important;
        background: #87cefa;
    }

    /* Toggle button styles */
    .onoffswitch {
        position: relative;
        width: 90px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
    }

    .onoffswitch-checkbox {
        display: none;
    }

    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        border: 0px solid #999999;
        border-radius: 20px;
    }

    .onoffswitch-inner {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }

    .onoffswitch-inner:before,
    .onoffswitch-inner:after {
        display: block;
        float: left;
        width: 50%;
        height: 25px;
        padding: 0;
        line-height: 25px;
        font-size: 18px;
        color: white;
        box-sizing: border-box;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        letter-spacing: 0.5px;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
    }

    .onoffswitch-inner:before {
        content: "Public";
        padding-left: 10px;
        background-color: #36B04C;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after {
        content: "Private";
        padding-right: 10px;
        background-color: #6c757d;
        color: #FFFFFF;
        text-align: right;
    }

    .onoffswitch-switch {
        display: block;
        width: 17px;
        height: 17px;
        margin: 4px;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 65px;
        border: 0px solid #999999;
        border-radius: 13px;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
        right: 0px !important;
    }

    .change_profile_status {
        display: flex;
        align-items: center;
        margin-top: 12px;
    }

    .change_profile_status_action label {
        margin-bottom: 0;
    }

    .change_profile_status_text {
        margin-right: 10px;
        font-size: 18px;
        color: #fffcc4;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
    }

    .member_list_filters_wrp {
        padding: 0px 0 5px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        .total_count_box {
            background: rgba(0, 0, 0, 0.75);
            padding: 0px 10px;
            border-radius: 3px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            cursor: pointer;
            color: #fff;
            height: 90px;
            box-shadow: 3px 3px 3px rgba(138, 145, 153, 0.1), -3px -3px 3px rgba(138, 145, 153, 0.1);

            &:hover {
                background: #87cefa;
                color: #000000;
            }

            &:hover .count_icon rect {
                fill: #000000;
            }

            &:hover .count_icon path {
                fill: #000000;
            }

            &:hover .count_icon circle {
                fill: #000000
            }

            &:hover .count_icon span {
                background: rgba(0, 0, 0, 0.1)
            }

            &.active {
                background: #87cefa;
                color: #000000;
            }

            &.active .count_icon rect {
                fill: #000000;
            }

            &.active .count_icon path {
                fill: #000000;
            }

            &.active .count_icon span {
                background: rgba(255, 255, 255, 0.15);
            }

            .hover_txt {
                display: none;
            }

            &.awerack_tab:hover .hover_txt,
            &.awerack_tab.active .hover_txt {
                display: block;
            }

            &.awerack_tab:hover .normal_txt,
            &.awerack_tab.active .normal_txt {
                display: none;
            }

            .fa-laptop {
                font-size: 32px;
                line-height: 50px;
                color: #ffc107;
            }

            &:hover .fa-laptop,
            &.active .fa-laptop {
                color: #000000;
            }
        }

        .count_icon span {
            width: 50px;
            display: inline-block;
            height: 50px;
            background: hsla(0, 0%, 100%, .1);
            border-radius: 50%;
            text-align: center;
            line-height: 50px;
        }

        .count_title_w_n {
            padding-left: 8px;
        }

        .count_number {
            display: block;
            font-size: 22px;
            font-weight: 600;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
        }

        .count_title {
            font-size: 18px;
            text-transform: capitalize;
            line-height: 1;
            // transition:all ease 0.5s;
            // -webkit-transition:all ease 0.5s;
            // -moz-transition:all ease 0.5s;
        }

        .row .col-sm-3 {
            padding-left: 5px;
            padding-right: 5px;
        }

        .row {
            margin-left: -5px;
            margin-right: -5px;
        }
    }

    .profile_avtar_img .img-fluid {
        width: 175px;
    }

    .profile_updation_notification {
        margin-top: 12px;
        font-size: 16px;
        color: #fffcc4;
        -webkit-animation: blink 1.5s linear infinite;
        -moz-animation: blink 1.5s linear infinite;
        -ms-animation: blink 1.5s linear infinite;
        -o-animation: blink 1.5s linear infinite;
        animation: blink 1.5s linear infinite;

        @media only screen and (max-width:480px) {
            margin-top: 5px;
            font-size: 14px;
        }

        a {
            color: #ffd400;
            text-decoration: none;

            &:hover {
                color: #87cefa;
            }

            @media only screen and (max-width:480px) {
                font-size: 14px;
            }
        }
    }

    @keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-webkit-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-moz-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-o-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    .user_info_label_value {
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
        font-size: 18px;
        word-break: break-word;
        color: #d6d6d6;
    }

    .bio_read_more_btn {
        color: #87cefa;
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: #ffd400;
        }
    }

    .prfl_avatar_lazy_load_box {
        position: relative;
        width: 175px;
        min-height: 175px;
        overflow: hidden;

        @media only screen and (max-width:767px) {
            width: 125px;
            min-height: 125px;
        }

        .img-fluid {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            transition: transform ease 0.5s;
            -webkit-transition: transform ease 0.5s;
            -moz-transition: transform ease 0.5s;
            -webkit-backface-visibility: hidden;
            /* Safari */
            backface-visibility: hidden;
        }

        &:hover .img-fluid {
            transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
        }
    }

    .content_striped {
        white-space: pre-wrap;
        word-break: break-word;
    }

    .user_info_label .user_info_label_key .img-fluid {
        max-width: 32px;
    }

    .bio_cv_text_wrp {
        text-align: right;
        line-height: 1;
        margin-bottom: 10px;
        padding: 0 10px;

        a {
            color: #8e8d7f;
            text-decoration: none;
            font-size: 16px;
            font-family: 'georgiaregular';

            &:hover {
                color: #87cefa;
            }
        }
    }

    .personal_user_d_country {
        font-size: 18px;
        text-transform: capitalize;
        color: #8e8d7f;
        margin-top: 5px;
        line-height: 1;

        @media only screen and (max-width:767px) {
            font-size: 16px;
        }

        span {
            text-transform: uppercase;
        }
    }

    .user_prfl_about_tab_wrp {
        .btn-primary {
            cursor: pointer;
            position: relative;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: rgba(255, 255, 255, 0.12);
            color: #ffd400;
            border: none;
            border-radius: 3px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 16px;
            padding: 4px 10px;
            min-width: 80px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }

            &.active {
                background: #87cefa;
                color: #000000;
            }
        }
    }

    .about_user_info_content {
        margin: 0;
        padding: 0px 15px 20px 30px;

        li {
            font-size: 18px;
            margin-bottom: 5px;
            line-height: 1.3;
            position: relative;
            list-style-type: square;

            .about_info_value {
                color: #ffd400;

                &:last-child {
                    i {
                        display: none;
                    }
                }
            }

            .about_info_ico {
                position: absolute;
                left: 0;
                top: 0;

                * {
                    fill: #ffd400;
                }
            }

            &::marker {
                color: #ffd400;
            }

            @media only screen and (max-width:1310px) {
                font-size: 16px;
            }

            &:last-child {
                margin-bottom: 0px;
            }
        }
    }

    .user_prfl_about_tab_wrp .main_dashboard_user_info {
        height: calc(100dvh - 390px);
        overflow-y: auto;
        color: #d6d6d6;

        &::-webkit-scrollbar {
            width: 5px;
            background: #000000;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #232323;
            border-radius: 10px;
        }
    }
}

.animation_zoom_out {
    animation-name: zoomOutAnimation;
    animation-duration: 0.5s;
    -webkit-animation-name: zoomOutAnimation;
    -webkit-animation-duration: 0.5s;
}

@keyframes zoomOutAnimation {
    from {
        transform: scale(1);
        -webkit-transform: scale(0.97);
        -moz--transform: scale(0.97);
    }

    to {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz--transform: scale(1);
    }
}

@-webkit-keyframes zoomOutAnimation {
    from {
        transform: scale(1);
        -webkit-transform: scale(0.97);
        -moz--transform: scale(0.97);
    }

    to {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz--transform: scale(1);
    }
}

.coming_soon_tab {
    text-align: center;

    h4 {
        margin: 0;
        padding: 0;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #ffffff;
        font-size: 55px;
        font-weight: bold;
        font-family: 'Beon', 'Lato', sans-serif;
        width: 100%;
        text-align: center;

        &:before {
            content: attr(data-text);
            position: absolute;
            top: 0;
            left: 0;
            transform-origin: bottom;
            transform: rotateX(180deg);
            line-height: 1.14em;
            background: linear-gradient(0deg, #000000 0, transparent 70%);
            -webkit-background-clip: text;
            -webkit-text-color: transparent;
            opacity: 0.3;
            width: 100%;
            text-align: center;
        }
    }
}

@media only screen and (min-width: 1023px) {
    .main_dashboard_top>.row>.width_resize_5 {
        flex: 0 0 38%;
        max-width: 38%;
    }
}

.upload_cv_file {
    color: #87cefa;
    text-decoration: underline;
    letter-spacing: 2px;
    font-size: 26px;

    &:hover {
        color: #ffd400;
    }
}

.my_cv_section {
    padding: 0px 15px 35px;

    .cv_reupload {
        position: relative;

        .cv_loader_f_re {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
            padding-top: 15px;

            .img-fluid {
                width: 120px;
            }
        }
    }

    .cv_reupload_label {
        border: 1px dashed #424242;
        padding: 30px 15px;
        text-align: center;
        display: block;
        border-radius: 5px;
        color: #424242;
        cursor: pointer;

        .fa-cloud-upload {
            font-size: 72px;
        }

        .reupload_content {
            display: block;
            font-size: 20px;
            margin-top: 12px;
            letter-spacing: 1px;
        }

        &:hover {
            color: #ffd400;
            border-color: #ffd400;
        }
    }

    .cv_filename {
        font-size: 16px;
        color: #ffd400;
        line-height: 1.3;
        text-decoration: none;

        &:hover {
            color: #87cefa;
        }
    }
}

.cv_tab_f_toolbar {
    padding: 0px 15px 0px;
}

@media only screen and (min-width:768px) and (max-width:1310px) {
    .main_dashboard {
        .main_dashboard_tabs .nav-link {
            font-size: 16px !important;
        }

        .main_dashboard_tabs .nav-tabs .nav-item:nth-child(2) {
            padding: 0 20px;
        }

        .user_info_label_value {
            font-size: 16px;
        }

        .user_info_label .user_info_label_key .img-fluid {
            width: 30px;
        }

        .member_list_filters_wrp .count_title {
            font-size: 16px;
        }
    }
}
</style>